import { render, staticRenderFns } from "./0_Presentation.vue?vue&type=template&id=1aae54ec&scoped=true&"
import script from "./0_Presentation.vue?vue&type=script&lang=js&"
export * from "./0_Presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aae54ec",
  null
  
)

export default component.exports